import { useEffect, useState } from "react";
import styles from "../../../homepage/pages/Calculators.module.css";
import { analytics, logEvent } from "../../../../firebase.js";

import { BlockMath, InlineMath } from "react-katex";
import "katex/dist/katex.min.css";

import Select from "../components/Select.js";
import InputNumber from "../components/InputNumber.js";
import Output from "../components/Output.js";

import { concreteAnchorageLength } from "../../utils/services/calculators.js";
import { Text, useToast } from "@chakra-ui/react";

function ConcreteAnchorageLength({}) {
  const toast = useToast();
  // BAR GRIP
  const [anchorageLengthInputs, setAnchorageLengthInputs] = useState({
    fck: 20,
    fyk: 500,
    bar_type: "Barras sem gancho",
    grip: "Boa aderência",
    diameter: 6.3,
    as_cal: "",
    as_ef: "",
  });
  const [anchorageLengthOutputs, setAnchorageLengthOutputs] = useState({
    fbd: "",
    lb: "",
    lb_nec: "",
    lb_min: "",
    memorial: {},
  });

  function updateAnchorageLengthInputs(name, value) {
    if (value === "" || name === "bar_type" || name === "grip") {
      setAnchorageLengthInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else {
      setAnchorageLengthInputs((prevInputs) => ({
        ...prevInputs,
        [name]: parseFloat(value),
      }));
    }
    setAnchorageLengthOutputs({
      fbd: "",
      lb: "",
      lb_nec: "",
      lb_min: "",
    });
  }

  function onAnchorageLengthCalculate() {
    if (
      anchorageLengthInputs["as_cal"] === "" ||
      anchorageLengthInputs["as_ef"] === ""
    ) {
      toast({
        title: "Preencha todos os campos",
        status: "warning",
        isClosable: true,
      });
    } else if (
      anchorageLengthInputs["as_cal"] === 0 ||
      anchorageLengthInputs["as_ef"] === 0
    ) {
      toast({
        title: "Os valores devem ser diferentes de 0",
        status: "warning",
        isClosable: true,
      });
    } else if (
      anchorageLengthInputs["as_ef"] < anchorageLengthInputs["as_cal"]
    ) {
      toast({
        title: "A área de aço adotada deve ser maior que a de cálculo",
        status: "warning",
        isClosable: true,
      });
    } else {
      concreteAnchorageLength(anchorageLengthInputs).then((response) => {
        setAnchorageLengthOutputs(response["data"]);
        logEvent(analytics, "button_click", {
          button_name: "concrete-anchorage-length-calculator-button",
        });
      });
    }
  }

  useEffect(() => {
    logEvent(analytics, "page_view", {
      page: "concrete-anchorage-length-calculator",
    });
  }, []);

  return (
    <div className={styles.section} key={"header"}>
      <h1 className={styles.calculatorName}>Comprimento de Ancoragem:</h1>
      <div className={styles.calculator}>
        <div className={styles.inputs}>
          <div className={styles.inputRow}>
            <h3 className={styles.rowTitle}>Dados de entrada:</h3>
          </div>
          <div className={styles.inputRow}>
            <Select
              text="fck"
              elements={[
                20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90,
              ]}
              unit="MPa"
              onChange={(e) =>
                updateAnchorageLengthInputs("fck", e.target.value)
              }
            />
            <Select
              text="fyk"
              elements={[500]}
              unit="MPa"
              onChange={(e) =>
                updateAnchorageLengthInputs("fyk", e.target.value)
              }
            />
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Tipo"
              elements={["Barras sem gancho", "Barras com gancho"]}
              unit=""
              onChange={(e) =>
                updateAnchorageLengthInputs("bar_type", e.target.value)
              }
            />
            <Select
              text="Zona"
              elements={["Boa aderência", "Má aderência"]}
              unit=""
              onChange={(e) =>
                updateAnchorageLengthInputs("grip", e.target.value)
              }
            />
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Ø"
              elements={[6.3, 8, 10, 12.5, 16, 20, 25, 32]}
              unit="mm"
              onChange={(e) =>
                updateAnchorageLengthInputs("diameter", e.target.value)
              }
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="As,cal"
              unit="cm²"
              onChange={(e) =>
                updateAnchorageLengthInputs("as_cal", e.target.value)
              }
            />
            <InputNumber
              text="As,adot"
              unit="cm²"
              onChange={(e) =>
                updateAnchorageLengthInputs("as_ef", e.target.value)
              }
            />
          </div>
        </div>
        <div className={styles.buttons}>
          <button
            className={styles.calculateButton}
            onClick={onAnchorageLengthCalculate}
          >
            CALCULAR
          </button>
        </div>
        <div className={styles.outputs}>
          <div className={styles.outputRow}>
            <h3 className={styles.rowTitle}>Resumo de resultados:</h3>
          </div>
          <Output
            text="fbd"
            value={anchorageLengthOutputs["fbd"]}
            unit="kN/cm²"
          />
          <div className={styles.outputRow}>
            <Output text="Lb" value={anchorageLengthOutputs["lb"]} unit="cm" />
            {`(${Math.ceil(anchorageLengthOutputs["lb"] / (anchorageLengthInputs["diameter"] / 10))}Ø)`}
          </div>
          <Output
            text="Lb,nec"
            value={anchorageLengthOutputs["lb_nec"]}
            unit="cm"
          />
          <Output
            text="Lb,min"
            value={anchorageLengthOutputs["lb_min"]}
            unit="cm"
          />
        </div>
      </div>
      <div className={styles.memorial} key={"memorial"}>
        <h1>Memorial de Cálculo:</h1>
        {anchorageLengthOutputs["memorial"] &&
          Object.entries(anchorageLengthOutputs["memorial"]).map(
            ([className, subclasses]) => (
              <>
                <h2>{className}</h2>
                {Object.entries(subclasses).map(([subclassName, steps]) => (
                  <>
                    <h3>{subclassName}</h3>
                    {steps.map((step) => (
                      <>
                        <h4>{step["description"]}</h4>
                        <div className={styles.mathContainer}>
                          <BlockMath
                            math={step["formula"] + step["calculation"]}
                          />
                        </div>
                      </>
                    ))}
                  </>
                ))}
              </>
            )
          )}
      </div>
    </div>
  );
}

export default ConcreteAnchorageLength;
